/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Code_BodyInputs */



/**
* | output |
* | --- |
* | "Enter the 6-digit code from your authenticator app." |
*
* @param {Signin_Code_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_code_body = /** @type {((inputs?: Signin_Code_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Code_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Enter the 6-digit code from your authenticator app.")
});